import {type Type} from '@packages/systems/wfdl';

export const migrateReferenceTypeStructure = (dataTypeJson: any) => {
  if (
    dataTypeJson &&
    dataTypeJson.type === 'TypeReference' &&
    typeof dataTypeJson.val === 'undefined'
  ) {
    const newDataType: Type = {
      type: 'TypeReference',
      val: dataTypeJson.name,
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
